import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PriceBookEntryPayload } from 'models/PriceBookEntry';
import { PricingRules, ProductCatalogItem, ProductCatalogItemPayload } from 'models/ProductCatalog';

interface InitialState {
  successItems: ProductCatalogItem[];
  errorItems: { errors: string[]; productNumber: string }[];
  importTotal: number;
  importItems: ProductCatalogItemPayload[];
  importPricingRules: { [key: string]: PricingRules[] };
  importPriceBookEntries: PriceBookEntryPayload[];
}

const initialState: InitialState = {
  successItems: [],
  errorItems: [],
  importTotal: 0,
  importItems: [],
  importPricingRules: {},
  importPriceBookEntries: []
};

export const importSlice = createSlice({
  name: 'import',
  initialState,
  reducers: {
    setSuccessItems: (state, { payload }: PayloadAction<InitialState['successItems']>) => {
      state.successItems = payload;
    },
    setErrorItems: (state, { payload }: PayloadAction<InitialState['errorItems']>) => {
      state.errorItems = payload;
    },
    addSuccessItem: (state, { payload }: PayloadAction<InitialState['successItems'][number]>) => {
      state.successItems = [...state.successItems, payload];
    },
    addErrorItem: (state, { payload }: PayloadAction<InitialState['errorItems'][number]>) => {
      state.errorItems = [...state.errorItems, payload];
    },
    setImportTotal: (state, { payload }: PayloadAction<InitialState['importTotal']>) => {
      state.importTotal = payload;
    },
    setImportItems: (state, { payload }: PayloadAction<InitialState['importItems']>) => {
      state.importItems = payload;
    },
    setImportPricingRules: (state, { payload }: PayloadAction<InitialState['importPricingRules']>) => {
      state.importPricingRules = payload;
    },
    setImportPriceBookEntries: (state, { payload }: PayloadAction<InitialState['importPriceBookEntries']>) => {
      state.importPriceBookEntries = payload;
    }
  }
});

export const { setErrorItems, setSuccessItems, addErrorItem, addSuccessItem, setImportTotal, setImportItems, setImportPricingRules, setImportPriceBookEntries } = importSlice.actions;
